import React from "react";
import { render } from "react-dom";
import { Router, Route, IndexRedirect } from "react-router";
import { Provider } from "react-redux";
import ReactGA from "react-ga";
import WebfontLoader from "@dr-kobros/react-webfont-loader";
import { register as registerServiceWorker } from "./serviceWorkerRegistration";

import "./css/style.css";

import "svg-classlist-polyfill";
import App from "./components/App";
import RoutePlanning from "./components/RoutePlanning";
import LeisureRides from "./components/LeisureRides";
import CycleRoutes from "./components/CycleRoutes";
import ExploreMap from "./components/ExploreMap";
import BikeRentals from "./components/BikeRentals";
import SkipTo from "./components/SkipTo";
import PublicPumps from "./components/PublicPumps";

import Error from "./components/Error";

import store, { history } from "./store";

import config from "./config";

//* local
window.ROOT = config.windowRoot;
window.PORT = config.windowPort;
window.WEBSITE_ROOT = config.websiteUrl;

//* production
window.QUERY_ROOT = "https://admin.cycleplanner.betterbybike.info/";

// Webfontloader configuration object. *REQUIRED*.
const configLoad = {
    typekit: { id: "pxc7hlo" },
};

// Google Analytics
ReactGA.initialize("UA-10938530-1", {
    debug: false,
});

// GA page view via router
const GAPageView = () => {
    let locationURL = window.location.pathname + window.location.search;
    let trackerSet = { page: locationURL };
    if (locationURL.indexOf("?locations") > -1) {
        locationURL = `route-planning?locations`;

        trackerSet = {
            location: locationURL,
        };
    }

    ReactGA.set({ trackerSet });
    ReactGA.pageview(locationURL);

    // TODO: Review this with PeteT - this code was causing the page to scroll to the top on url change
    // if (window.innerWidth < 1000) {
    //     window.scrollTo(0, 0);
    // }
};

history.listen((location, action) => {
    GAPageView();
});

const router = (
    <Provider store={store}>
        <div>
            <SkipTo />
            <WebfontLoader config={configLoad}>
                <Router history={history} onUpdate={GAPageView}>
                    <Route path="/" component={App}>
                        <Route
                            path="/route-planning"
                            component={RoutePlanning}
                        />

                        <Route path="/leisure-rides" component={LeisureRides}>
                            <Route
                                path="/leisure-rides(/:ridename)"
                                component={LeisureRides}
                            />
                        </Route>

                        <Route path="/cycle-routes" component={CycleRoutes}>
                            <Route
                                path="/cycle-routes/regional(/:cycleroutesregions)(/:routename)"
                                component={CycleRoutes}
                            />
                            <Route
                                path="/cycle-routes(/:routearea)(/:routename)"
                                component={CycleRoutes}
                            />
                        </Route>

                        <Route path="/explore-map" component={ExploreMap} />
                        <Route
                            path="/cycle-hire"
                            component={BikeRentals}
                        ></Route>

                        <Route path="/public-pumps" component={PublicPumps} />

                        <Route path="*" component={Error} />

                        <IndexRedirect to="route-planning" />
                    </Route>
                </Router>
            </WebfontLoader>
        </div>
    </Provider>
);

render(router, document.querySelector("#root"));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js